<template>
    <div>
        <div class="container">
            <h1 class="page-title text-center mt-5">Event/Online Class</h1>
            <h2 class="sub-title text-center mb-4 mb-md-5" v-html="$t('message.eventclassdetail')"></h2>

            <div class="row mb-3" v-if="!isHighlightsLoaded">
                <div class="col-12 col-md-6 placeholder" v-for="index in 6" :key="index">
                    <div class="blog-article">
                        <div class="thumbnail mb-3"></div>
                        <div class="paragraph mb-4" style="width: 30%;"></div>
                        <div class="paragraph mb-2" style="width: 100%;"></div>
                        <div class="paragraph" style="width: 80%;"></div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="isHighlightsLoaded">
              <div :class="['col-12', key !== 0 ? 'col-md-6' : '']" v-for="(post, key) in highlights.acf.posts" :key="key">
                <router-link :to="{ name: post.post_type, params: { slug: post.post_name } }">
                    <div :class="['blog-article', key === 0 ? 'picked' : '']">
                        <div class="thumbnail">
                            <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }">
                                <img :data-src="`${post.post_thumbnail_md}`" :data-srcset="`${post.post_thumbnail_lg} 2x`" class="d-block m-auto" v-if="key !== 0" />
                                <img :data-src="`${post.post_thumbnail_lg}`" :data-srcset="`${post.post_thumbnail_lg} 2x`" class="d-block m-auto" v-if="key === 0" />
                            </div>
                            <!-- /.thumbnail-media -->
                            <div class="article-duration" v-html="post.acf.video_duration" v-if="post.post_type === 'video'"></div>
                        </div>
                        <!-- /.thumbnail -->
                        <div class="blog-desc">
                          <div class="category" v-html="post.post_type === 'event' ? $t('message.event') : $t('message.video')"></div>
                          <div class="description" v-html="post.post_title"></div>
                          <p class="d-none d-md-block" v-html="post.acf.event_location"></p>
                          <p class="event-schedule d-none d-md-block" v-html="post.acf.event_schedule"></p>
                        </div>
                        <!-- /.blog-desc -->
                    </div>
                    <!-- /.blog-article -->
                </router-link>
              </div>
            </div>
        </div>
        <!-- /.container -->

        <!-- Events -->
        <div class="container" id="all-events">
            <div class="separate"></div>

            <h1 class="page-title text-center mt-5">ALL EVENTS</h1>
            <h2 class="sub-title text-center mb-4 mb-md-5" v-html="$t('message.allevents')"></h2>

            <div class="row mb-3" v-if="!isEventLoaded">
                <div class="col-12 col-md-6 col-lg-4 placeholder" v-for="index in 3" :key="index">
                    <div class="blog-article">
                        <div class="thumbnail mb-3"></div>
                        <div class="paragraph mb-4" style="width: 30%;"></div>
                        <div class="paragraph mb-2" style="width: 100%;"></div>
                        <div class="paragraph" style="width: 80%;"></div>
                    </div>
                </div>
            </div>

            <div class="row mb-3" v-if="isEventLoaded">
                <div class="col-12 col-md-6 col-lg-4" v-for="(event, key) in events" :key="key">
                    <router-link :to="{ name: event.type, params: { slug: event.slug } }">
                        <div class="blog-article">
                            <div class="thumbnail">
                                <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }" v-if="event._embedded">
                                    <img :data-src="`${event._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url}`" :data-srcset="`${event._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`" class="d-block m-auto" />
                                </div>
                                <!-- /.thumbnail-media -->
                            </div>
                            <!-- /.thumbnail -->
                            <div class="blog-desc">
                              <div class="category" v-html="$t('message.event')"></div>
                              <div class="description" v-html="event.title.rendered"></div>
                            </div>
                            <!-- /.blog-desc -->
                        </div>
                        <!-- /.blog-article -->
                    </router-link>
                </div>
            </div>
            <!-- /.row -->

            <div class="row mb-5">
                <div class="col text-center" v-if="isEventLoaded">
                  <router-link :to="{ name: 'EventLanding' }" class="btn dark" v-html="$t('message.viewmore')"></router-link>
                </div>
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container -->

        <!-- Videos -->
        <div class="container" id="all-videos">
          <div class="separate"></div>

          <h1 class="page-title text-center mt-5">ALL ONLINE CLASS</h1>
          <h2 class="sub-title text-center mb-4 mb-md-5" v-html="$t('message.videdetail')"></h2>

          <div class="row mb-3" v-if="!isVideosLoaded">
              <div class="col-12 col-md-6 col-lg-4 placeholder" v-for="index in 3" :key="index">
                  <div class="blog-article">
                      <div class="thumbnail mb-3"></div>
                      <div class="paragraph mb-4" style="width: 30%;"></div>
                      <div class="paragraph mb-2" style="width: 100%;"></div>
                      <div class="paragraph" style="width: 80%;"></div>
                  </div>
              </div>
          </div>

          <div class="row mb-3" v-if="isVideosLoaded">
              <div class="col-12 col-md-6 col-lg-4" v-for="(video, key) in videos" :key="key">
                  <router-link :to="{ name: video.type, params: { slug: video.slug } }">
                      <div class="blog-article">
                          <div class="thumbnail">
                              <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }" v-if="video._embedded">
                                  <img :data-src="`${video._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url}`" :data-srcset="`${video._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`" class="d-block m-auto" />
                              </div>
                              <!-- /.thumbnail-media -->
                              <div class="article-duration" v-html="video.acf.video_duration"></div>
                          </div>
                          <!-- /.thumbnail -->
                          <div class="blog-desc">
                            <div class="category" v-html="$t('message.video')"></div>
                            <div class="description" v-html="video.title.rendered"></div>
                          </div>
                          <!-- /.blog-desc -->
                      </div>
                      <!-- /.blog-article -->
                  </router-link>
              </div>
          </div>
          <!-- /.row -->

          <div class="row mb-5">
              <div class="col text-center" v-if="isVideosLoaded">
                  <router-link :to="{ name: 'VideoLanding' }" class="btn dark" v-html="$t('message.viewmore')"></router-link>
              </div>
          </div>
          <!-- /.row -->
        </div>
        <!-- /#all-videos.container -->
    </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'EventClass',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      events: [],
      isEventLoaded: false,
      highlights: [],
      isHighlightsLoaded: false,
      videos: [],
      isVideosLoaded: false
    }
  },
  mounted () {
    document.title = `Event / Online Class - ${this.title}`
    this.getHighlights()
    this.getVideos()
    this.getEvents()
  },
  methods: {
    getEvents () {
      const lang = this.$route.params.lang
      if (!this.events.length) {
        const $vm = this
        axios.get(`${this.api_path}wp-json/wp/v2/event`, {
          params: {
            _embed: true,
            per_page: 6,
            lang
          }
        })
          .then(res => {
            if (res.data) {
              $vm.events = res.data
              $vm.isEventLoaded = true
            }
          })
      }
    },
    getHighlights () {
      const lang = this.$route.params.lang
      const $vm = this
      axios.get(`${this.api_path}wp-json/wp/v2/pages`, {
        params: {
          _embed: true,
          slug: 'event-class',
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.highlights = res.data[0]
            $vm.isHighlightsLoaded = true
          }
        })
    },
    getVideos () {
      const lang = this.$route.params.lang
      if (!this.videos.length) {
        const $vm = this
        axios.get(`${this.api_path}wp-json/wp/v2/video`, {
          params: {
            _embed: true,
            per_page: 6,
            lang
          }
        })
          .then(res => {
            if (res.data) {
              $vm.videos = res.data
              $vm.isVideosLoaded = true
            }
          })
      }
    }
  }
}
</script>
